module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir7-510f5e32f6968e0da0bca6001cebb40a.jpg";